/** Rejects commas and other characters invalid in a domain. */
const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function isValidEmail(email: string): boolean {
  const trimmed = email.trim();
  if (!trimmed || trimmed.length > 254) {
    return false;
  }
  return EMAIL_REGEX.test(trimmed);
}

/** React Hook Form rules for a required email field. */
export const EMAIL_FIELD_RULES = {
  required: 'Please enter your email address',
  validate: (value: string) => isValidEmail(value) || 'Please enter a valid email address'
};
